module.exports = __webpack_public_path__ + "static/media/logos_youtube.87d6b74a.svg";